class AfterFourCarousel extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;
    this.slides = [...this.querySelectorAll('[data-af-slide]')];
    this.dots = [...this.querySelectorAll('[data-af-dot]')];
    this.index = 0;
    this.interval = Math.max(6000, Number(this.dataset.interval || 6000));
    this.autoplayEnabled = this.dataset.autoplay !== 'false';
    this.focusPaused = false;
    this.querySelector('[data-af-prev]')?.addEventListener('click', () => this.show(this.index - 1, true));
    this.querySelector('[data-af-next]')?.addEventListener('click', () => this.show(this.index + 1, true));
    this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.show(index, true)));
    this.addEventListener('focusin', (event) => {
      if (!event.target.matches?.(':focus-visible')) return;
      this.focusPaused = true;
      this.stop();
    });
    this.addEventListener('focusout', () => {
      window.requestAnimationFrame(() => {
        this.focusPaused = Boolean(this.querySelector(':focus-visible'));
        if (!this.focusPaused) this.start();
      });
    });
    this.handleVisibilityChange = () => (document.hidden ? this.stop() : this.start());
    document.addEventListener('visibilitychange', this.handleVisibilityChange);
    this.show(0);
    this.start();
  }

  disconnectedCallback() {
    this.stop();
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    this.initialized = false;
  }

  show(nextIndex, userInitiated = false) {
    if (!this.slides.length) return;
    this.index = (nextIndex + this.slides.length) % this.slides.length;
    this.classList.toggle('is-editorial', this.index !== 0);
    this.slides.forEach((slide, index) => {
      const active = index === this.index;
      slide.classList.toggle('is-active', active);
      slide.setAttribute('aria-hidden', String(!active));
    });
    this.dots.forEach((dot, index) => {
      const active = index === this.index;
      dot.classList.toggle('is-active', active);
      dot.setAttribute('aria-current', active ? 'true' : 'false');
    });
    const current = this.querySelector('[data-af-current]');
    if (current) current.textContent = String(this.index + 1).padStart(2, '0');
    if (userInitiated) this.start();
  }

  start() {
    this.stop();
    if (
      document.hidden ||
      this.focusPaused ||
      !this.autoplayEnabled ||
      window.matchMedia('(prefers-reduced-motion: reduce)').matches ||
      this.slides.length < 2
    ) return;
    this.timer = window.setInterval(() => this.show(this.index + 1), this.interval);
  }

  stop() {
    if (this.timer) window.clearInterval(this.timer);
    this.timer = null;
  }
}

if (!customElements.get('after-four-carousel')) {
  customElements.define('after-four-carousel', AfterFourCarousel);
}
